import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import New from './New';
import Old from './Old';

const Layout = () => {
  const { resource } = useMetaLayoutContext();
  return resource.withRelationship(fr.relationships.experimentalUserInterface.name, () => {
    return <New />;
  }, () => {
    return <Old />;
  });
};

export default Layout;
